import cloneDeep from "lodash/cloneDeep.js";
import { locRecord } from "#src/extensions/filter-items.js";
import { withClipScale } from "#lib/framex/clip-scale.js";

/**
 * The canonical "set a page's scale" write, shared by Step 1's modal and the
 * scale-from-dimension dialog. (PageProperties.updateScale still carries its
 * own pre-extraction copy of this logic, deliberately — migrating the shared
 * legacy panel was skipped. A fix made here does NOT reach it.) Returns the
 * group.update() actions: the document diff, plus drawing_scale seeded onto
 * every frame clip on those pages that doesn't already carry an override —
 * keeping an item's drawing.clip in sync when the location is that item's
 * active attachment. Also used to clear a scale (value: null), which is why
 * it never touches notApplicable.
 *
 * `overrideExisting: true` writes the value onto every clip on those pages,
 * existing drawing_scale included — the dialogs' "Apply scale to existing
 * frames" checkbox. Same item sync rule. It only widens the write when a real
 * scale is being applied: clearing (value: null, i.e. None/N/A) never touches
 * a clip that carries its own drawing_scale, whatever the flag says.
 */
function pageScaleUpdates({
  doc,
  grp,
  indexedLocations,
  pageIds,
  value,
  overrideExisting = false,
}) {
  const data = cloneDeep(doc.data);
  pageIds.forEach((pageId) => {
    data.pages[pageId].scale = value;
  });

  const updates = [{ type: "document", id: doc.id, diff: { data } }];

  pageIds.forEach((pageId) => {
    const locs = indexedLocations[pageId] || [];

    locs.forEach((loc) => {
      if (
        loc.clip &&
        ((overrideExisting && value != null) || !loc.clip.drawing_scale)
      ) {
        const record = locRecord(loc, grp);
        const clip = withClipScale(loc.clip, value, {
          heightInches: record?.cache?.height_in,
        });
        updates.push({
          type: "location",
          id: loc.id,
          diff: { clip },
        });

        if (record?.drawing?.attachment_id === loc.id) {
          const drawing = cloneDeep(record.drawing);
          drawing.clip = clip;
          updates.push({
            type: loc.record_type === "collection" ? "item" : loc.record_type,
            id: record.id,
            diff: { drawing },
          });
        }
      }
    });
  });

  return updates;
}

export default pageScaleUpdates;
